import { Formik } from 'formik'
import { Dialog } from 'primereact/dialog'
import React from 'react'
import { useTranslation } from 'react-i18next'
import SharedInputText from '../../components/Shared/SharedInputText'
import SharedButton from '../../components/Shared/SharedButton'
import * as yup from 'yup'
import validSupergitHIS from '../../api/validSupergitHIS'
import toast from 'react-hot-toast'
function CancelModal ({
  open,
  setOpen,
  selectedData,
  setSelectedEntry,
  fetchListData
}) {
  const { t } = useTranslation()
  const [loading, setLoading] = React.useState(false)
  const initialValues = {
    reason: ''
  }

  const validationSchema = yup.object().shape({
    reason: yup.string()
  })
  console.log(selectedData)

  const handleSubmit = async (values, { setSubmitting }) => {
    setSubmitting(true)
    try {
      const response = await validSupergitHIS.post(
        'insurance_claim_invoices/revoke',
        {
          id: selectedData?.id,
          reason: values?.reason
        }
      )
      if (response) {
        toast.success(response?.message)
        fetchListData()
      }
    } catch (err) {
      console.error(err)
    } finally {
      setOpen(false)
      setSubmitting(false)
      setSelectedEntry(null)
    }
  }
  return (
    <Dialog
      header={t('Cancel Claim Invoice')}
      visible={open}
      onHide={() => {
        if (!open) return
        setOpen(false)
        setSelectedEntry(null)
      }}
      pt={{
        root: { className: 'w-full lg:w-[500px] mx-4 overflow-auto' },
        header: { className: '!p-2 !bg-darkBg !text-white' },
        content: { className: '!p-3' },
        closeButton: {
          className: 'hover:!bg-black/20 !outline-none !shadow-none'
        },
        closeButtonIcon: { className: '!text-white' }
      }}
    >
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {props => (
          <div className='grid grid-cols-1 gap-4'>
            <SharedInputText
              label={t('reason')}
              name='reason'
              placeholder={`${t('enter')} ${t('reason')}`}
              className='!p-1.5'
            />
            <div className='flex justify-end gap-6 mt-6'>
              <SharedButton
                icon='pi pi-times'
                label={t('Cancel')}
                className='cancel-btn'
                onClick={() => {
                  setOpen(false)
                  setSelectedEntry(null)
                  props.resetForm()
                }}
              />
              <SharedButton
                type='submit'
                icon='pi pi-check'
                label={t('Submit')}
                className='submit-btn'
                disabled={props.isSubmitting}
                onClick={props.handleSubmit}
              />
            </div>
          </div>
        )}
      </Formik>
    </Dialog>
  )
}

export default CancelModal
